<script setup>
    import { defineProps } from 'vue'
    import { InformationCircleIcon, XCircleIcon } from '@heroicons/vue/solid'

    const props = defineProps({ item: { type: Object, required: true } })
</script>

<template>
    <div
        aria-live="assertive"
        class="w-72 flex items-end pb-6 pointer-events-none sm:items-start"
    >
        <div class="w-full flex flex-col items-center space-y-4 sm:items-end">
            <div
                :class="[
                    'max-w-sm w-full rounded-md pointer-events-auto overflow-hidden shadow-lg shadow-black/30',
                    'bg-neutral-700 dark:bg-neutral-500'
                ]"
            >
                <div class="p-2">
                    <div class="flex items-start">
                        <div class="flex-shrink-0">
                            <InformationCircleIcon
                                class="h-6 w-6 text-gray-300 dark:text-gray-300"
                                aria-hidden="true"
                            />
                        </div>
                        
                        <div class="ml-3 w-0 flex-1 pt-0.5">
                            <p
                                v-if="props.item?.title"
                                class="text-sm font-medium text-gray-300 dark:text-gray-300 notification_title"
                            >
                                {{ props.item?.title }}
                            </p>
                        </div>
                        
                        <div class="ml-4 flex-shrink-0 flex">
                            <button
                                class="rounded-md chat_transition inline-flex notification_button focus:outline-none focus:ring-2 focus:ring-offset-2"
                                @click="$notify.close(props.item.id)"
                            >
                                <span class="sr-only">Fechar</span>
                                
                                <XCircleIcon
                                    name=""
                                    class="h-5 w-5 text-neutral-500 dark:text-gray-400"
                                    aria-hidden="true"
                                />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
